var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ban-solid",
    d: "M88.214,99.1,23.9,34.786A46.12,46.12,0,0,0,88.214,99.1ZM99.1,88.214A46.12,46.12,0,0,0,34.786,23.9ZM123,61.5A61.5,61.5,0,1,1,61.5,0,61.5,61.5,0,0,1,123,61.5Z",
    fill: "#d55b69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanSolid);
export default __webpack_public_path__ + "static/media/ban-solid.7402906c9136128b51465e702baed418.svg";
export { ForwardRef as ReactComponent };